export const ENVIRONMENTS = ['development', 'test', 'production'] as const
export type TEnvironments = typeof ENVIRONMENTS[number]
import FeaturesState from "../../../../config/features.yml"

export const FeatureIds: string[] = Object.keys(FeaturesState)
export type TFeatureIds = typeof FeatureIds[number]

type TFeatureStatus = { [k in TEnvironments]: boolean}
export interface IFeature extends TFeatureStatus {
  name: string
  description: string
}
export type TFeatures = {[key in TFeatureIds]: IFeature }
